import { useContext } from 'react';
import { roles } from 'cassandra-shared-js/roles';
import { AppCtx } from '../AppCtx';
import { hasPermission } from '../roles-actions-permissions';
import { useAuth } from '../AuthCtx';

const usePermissions = () => {
  const { user } = useAuth();
  const { fakeRole } = useContext(AppCtx);

  const role = fakeRole?.value || user?.role.name;
  const roleKey = Object.keys(roles).find((k) => { return roles[k]?.toLowerCase() === role?.toLowerCase(); });

  const hasPermissions = hasPermission(roleKey);

  const userHasRole = (rolesArray) => {
    return rolesArray.includes(role);
  };

  const userHasRoleExact = (rolesArray) => {
    return rolesArray === role;
  };

  return {
    hasPermissions,
    userHasRole,
    userHasRoleExact,
    role,
  };
};

export default usePermissions;
